import RegionModel from 'Models/RegionModel';
import GameModel from 'Models/GameModel';
import PaymentSystemModel from 'Models/PaymentSystemModel';
import { regExpProductIdFromSlug } from 'Root/helpers/regexps';
import { TAGS_AS_PRODUCTS_LIST } from 'Root/helpers/env';
import { round } from 'Root/helpers/tools';

export function extractIdFromSlug(slug) {
  const match = `${slug}`.match(regExpProductIdFromSlug);
  return match?.[1];
}

export function getUpsaleTagProductIdByLink(slug) {
  // split & shift для удаления параметров из урла
  return TAGS_AS_PRODUCTS_LIST
    .find(
      (tag) => !tag?.isGold
        && !tag?.isBlockedForUpsale
        // split & shift для удаления параметров из урла
        && slug.split('?').shift()
          .endsWith(`/${GameModel.ID_TO_DATA[tag.gameId].routeNamespace}-boost/${tag.tagUrl}`),
    )?.offerId;
}

export function cleanProduct(product) {
  if (!product) {
    return null;
  }

  const productCopy = JSON.parse(JSON.stringify(product));
  if (productCopy.options) {
    productCopy.options = productCopy.options.filter((o) => !o.disabled);
  }

  if (productCopy.meta?.difficulties) {
    productCopy.meta.difficulties = productCopy.meta.difficulties.filter((d) => !d.disabled);
    productCopy.meta.difficulties.forEach((d) => {
      d.options = d.options.filter((o) => !o.disabled);
    });
  }

  return productCopy;
}

export function transformProductPriceToRange(range) {
  const borderValuesDiff = range.borderValues[1] - range.borderValues[0];
  const priceZones = Object.keys(Object.values(range.prices)[0]);

  if (!priceZones.length) {
    return null;
  }

  return priceZones.map((startPriceZones, index) => {
    const startPosition = index === 0 && Number(startPriceZones) !== range.borderValues[0]
      ? range.borderValues[0]
      : Number(startPriceZones);

    const endPosition = priceZones[index + 1]
      ? Number(priceZones[index + 1])
      : range.borderValues[1];

    const step = range.zoneSteps?.[startPosition] || range.step;

    const size = range.zoneWidth?.[startPosition]
      ? range.zoneWidth[startPosition]
      : ((endPosition - startPosition) / borderValuesDiff) * 100;

    return {
      from: startPosition,
      to: endPosition,
      prices: RegionModel.LIST.reduce((prices, region) => {
        prices[region.id] = range.prices[region.id][startPosition] || null;

        return prices;
      }, {}),
      size: size > 100 ? 100 : size,
      step: Number(step),
    };
  });
}

export function extractUpsaleRefFromUrl(url) {
  return new URL(url).searchParams.get('upsale_ref');
}

/**
 Возвращает цену с учетом комиссии платежной системы
 @param {number} price - цена без комиссии
 @param {number, null} selectedPaymentMethod - id платежной системы (если null, то комиссия не учитывается)
 @param {object} options - дополнительные опции
 @param {number} options.regionId - id региона
 @param {boolean} options.isFirstPurchase - первая покупка пользователя
 @returns {number}
 */
export function getPriceWithCommission(price, selectedPaymentMethod, options) {
  if (!price || !Number.isFinite(price)) {
    return 0;
  }

  if (!selectedPaymentMethod) {
    return price;
  }

  const defaultOptions = {
    regionId: RegionModel.EU.id,
    isFirstPurchase: false,
  };

  const {
    regionId,
    isFirstPurchase,
  } = { ...defaultOptions, ...options };
  /*
    Процент платежной системы
    @see resources/assets/js/models/PaymentSystemModel.js
   */
  const isUSA = regionId === RegionModel.USA.id;
  const { mulModifier, baseCommission } = PaymentSystemModel.ID_TO_DATA[selectedPaymentMethod];
  let { firstPurchaseMulModifier } = PaymentSystemModel.ID_TO_DATA[selectedPaymentMethod];

  let commissionPercent = 0;
  let fixedCommission = 0;

  const isCardMethod = [...PaymentSystemModel.STRIPE_METHODS_LIST,
    PaymentSystemModel.METHODS.ECOMMPAY.id,
    PaymentSystemModel.METHODS.PAYPAL_CARD.id,
    PaymentSystemModel.METHODS.CHECKOUT.id]
    .includes(selectedPaymentMethod);

  // SKY-5316 disable ecommpay commission for the USA on first purchase
  if (isUSA && isCardMethod && isFirstPurchase) {
    firstPurchaseMulModifier = 0;
  }

  if (isCardMethod) {
    commissionPercent = isFirstPurchase && isUSA ? 0 : (mulModifier || 0);
    fixedCommission = baseCommission;
  } else if (isFirstPurchase && typeof firstPurchaseMulModifier !== 'undefined') {
    commissionPercent = firstPurchaseMulModifier;
  } else {
    commissionPercent = mulModifier || 0;
  }

  if (PaymentSystemModel.STRIPE_METHODS_LIST.includes(selectedPaymentMethod) && !isFirstPurchase) {
    fixedCommission += PaymentSystemModel.STRIPE_RADAR_FIX_COMMISION[regionId];
  }

  return round(price / (1 - (commissionPercent / 100)) + fixedCommission, 2);
}

export function openSellerPage(userId, settingId) {
  const url = `${window.location.origin}/seller/${userId}${settingId ? `?game=${settingId}` : ''}`;

  window.open(url, '_blank');
}
